<template>
  <div class="page-container">
    <el-card class="card-top" shadow="hover">
      <div class="card-actions">
        <el-form :inline="true" :model="searchForm" size="small" @submit.native.prevent>
          <el-form-item label="教练名称">
            <el-input v-model="searchForm.coachName" placeholder="请输入教练名称" clearable />
          </el-form-item>
          <el-form-item label="项目名称">
            <el-select v-model="searchForm.vehicleType" placeholder="请选择车辆" filterable clearable style="width: 180px">
              <el-option v-for="item in vehicleOptions" :key="item.vehicleType" :label="item.description || (item.brand + '-' + item.model + '-' + item.licensePlate)" :value="item.vehicleType" />
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker v-model="searchForm.startDateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择开始时间" clearable style="width: 180px" />
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker v-model="searchForm.endDateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择结束时间" clearable style="width: 180px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="card-table" shadow="hover">
      <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">新增排班</el-button>

      <el-table :data="coaches" border stripe style="width: 100%;margin-top: 20px;" size="small" height="500px">
        <el-table-column prop="vehicleDescription" label="项目" align="center" width="300" />
        <el-table-column prop="vehicleDescription" label="范围" align="center" width="350">
          <template slot-scope="scope">
            {{ scope.row.startDateTime }} - {{ scope.row.endDateTime }}
          </template>
        </el-table-column>
        <el-table-column prop="regionName" label="所属区域" align="center" width="100" />
        <el-table-column prop="coachName" label="教练" align="center" width="100" />
        <el-table-column prop="coachGender" label="教练性别" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.coachGender === 'MALE'? '男' : '女' }}
          </template>
        </el-table-column>
        <el-table-column prop="price" label="可预约量" align="center" width="100" />
        <el-table-column prop="maxBookingCount" label="最大量" align="center" />
        <el-table-column prop="notes" label="备注" align="center" />
        <el-table-column prop="createdAt" label="创建时间" align="center" width="200" />
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" style="color: #409EFF" size="small" @click="editTimeSlot(scope.row)">编辑</el-button>
            <el-button type="text" style="color: #F56C6C" size="small" @click="deleteCoach(scope.row)">删除</el-button>
            <el-button type="text" style="color: #409EFF" size="small" @click="viewAppointments(scope.row)">查看预约详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-pagination">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="size" :current-page="page"
          @current-change="handlePageChange" />
      </div>
    </el-card>

    <el-dialog :title="isEdit ? '编辑排班' : '新增排班'" :visible.sync="visible" width="640px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="120px" size="small">
        <el-form-item label="车辆名称" prop="vehicleId">
          <el-select v-model="form.vehicleId" placeholder="请选择车辆" filterable clearable style="width: 100%"
            @change="handleVehicleChange">
            <el-option v-for="item in vehicleOptions" :key="item.id" :label="item.description" :value="item.id" />
          </el-select>
        </el-form-item>
        <!-- 编辑模式：单个教练/区域 -->
        <template v-if="isEdit">
          <el-form-item label="教练名称" prop="coachId">
            <el-select v-model="form.coachId" placeholder="请选择教练" filterable clearable style="width: 100%"
              :disabled="!form.vehicleId" @change="val => handleCoachChangeForEdit(val)">
              <el-option v-for="item in coachOptions" :key="item.coachId" :label="item.coach.name"
                :value="item.coachId" />
            </el-select>
          </el-form-item>
          <el-form-item label="区域名称" prop="regionId">
            <el-select v-model="form.regionId" placeholder="请选择区域" :disabled="regionOptions.length === 0" style="width: 100%">
              <el-option v-for="item in regionOptions" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </template>

        <!-- 新增模式：支持多组教练/区域横向添加 -->
        <template v-else>
          <el-form-item label="教练与区域" required>
            <div class="pair-container">
              <div v-for="(pair, index) in form.coachRegionPairs" :key="index" class="pair-row">
                <el-form-item :prop="'coachRegionPairs.' + index + '.coachId'"
                              :rules="[{ required: true, message: '请选择教练', trigger: 'change' }]"
                              label-width="0"
                              class="pair-form-item">
                  <el-select v-model="pair.coachId" placeholder="选择教练" filterable clearable class="pair-select"
                    :disabled="!form.vehicleId" @change="() => handleCoachChangeForAdd(index)">
                    <el-option v-for="item in coachOptions" :key="item.coachId" :label="item.coach.name"
                      :value="item.coachId" />
                  </el-select>
                </el-form-item>
                <el-form-item :prop="'coachRegionPairs.' + index + '.regionId'"
                              :rules="[{ required: true, message: '请选择区域', trigger: 'change' }]"
                              label-width="0"
                              class="pair-form-item">
                  <el-select v-model="pair.regionId" placeholder="选择区域" clearable class="pair-select"
                    :disabled="!pair.coachId || !pair.regionOptions || pair.regionOptions.length === 0">
                    <el-option v-for="item in pair.regionOptions || []" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-button v-if="index === 0" type="primary" icon="el-icon-plus" circle size="mini" @click="addCoachRegionPair" />
                <el-button v-if="index > 0" type="text" icon="el-icon-close" @click="removeCoachRegionPair(index)" />
              </div>
            </div>
            <div class="pair-hint">可添加多组教练与区域，保存时将为每组创建一个排班</div>
          </el-form-item>
        </template>
        <el-form-item label="预约量" prop="price">
          <el-input v-model.number="form.price" placeholder="请输入预约量" size="small" />
        </el-form-item>
        <el-form-item label="开始时间" prop="startDateTime">
          <el-date-picker v-model="form.startDateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间" style="width: 100%" />
        </el-form-item>
        <el-form-item label="结束时间" prop="endDateTime">
          <el-date-picker v-model="form.endDateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间" style="width: 100%" />
        </el-form-item>
        <el-form-item label="时间段备注" prop="notes">
          <el-input v-model="form.notes" placeholder="请输入时间段备注" size="small" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CoachManage',
  data() {
    return {
      coaches: [],
      total: 0,
      page: 1,
      size: 20,
      visible: false,
      isEdit: false,
      form: {
        coachId: '',
        vehicleId: '',
        startDateTime: '',
        endDateTime: '',
        notes: '',
        price: '',
        regionId: '',
        coachRegionPairs: [
          { coachId: '', regionId: '', regionOptions: [] }
        ],
      },
      searchForm: {
        coachName: '',
        vehicleType: '',
        startDateTime: '',
        endDateTime: ''
      },
      coachOptions: [],
      vehicleOptions: [],
      regionOptions: [],
      rules: {
        coachId: [
          { required: true, message: '请选择教练', trigger: 'change' }
        ],
        regionId: [
          { required: true, message: '请选择区域', trigger: 'change' }
        ],
        vehicleId: [
          { required: true, message: '请选择车辆', trigger: 'change' }
        ],
        startDateTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endDateTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ],
        notes: [
          { required: true, message: '请输入时间段描述', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入预约量', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async openAddDialog() {
      this.isEdit = false;
      this.form = {
        vehicleId: '',
        coachId: '',
        startDateTime: '',
        endDateTime: '',
        notes: '',
        price: '',
        regionId: '',
        coachRegionPairs: [
          { coachId: '', regionId: '', regionOptions: [] }
        ]
      };
      // 移入 form 内部，便于基于 prop 的校验
      this.coachOptions = [];
      this.regionOptions = [];
      this.visible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    async handleVehicleChange(vehicleId) {
      this.form.coachId = '';
      if (!vehicleId) {
        this.coachOptions = [];
        return;
      }
      try {
        const res = await axios.get(`/api/coach-vehicles/vehicle/${vehicleId}`);
        this.coachOptions = res.data || [];
        console.log("🚀 ~ handleVehicleChange ~ this.coachOptions:", this.coachOptions)
      } catch (e) {
        this.coachOptions = [];
      }
    },
    async handleCoachChange(coachId) {
      this.form.regionId = '';
      this.regionOptions = [];
      if (!coachId) return;
      try {
        const res = await axios.get(`/api/coaches/${coachId}/regions`);
        this.regionOptions = res.data || [];
      } catch (e) {
        this.regionOptions = [];
      }
    },
    async handleCoachChangeForEdit(coachId) {
      await this.handleCoachChange(coachId)
    },
    async handleCoachChangeForAdd(index) {
      const pair = this.form.coachRegionPairs[index]
      pair.regionId = ''
      pair.regionOptions = []
      if (!pair.coachId) return
      try {
        const res = await axios.get(`/api/coaches/${pair.coachId}/regions`);
        this.$set(this.form.coachRegionPairs[index], 'regionOptions', res.data || [])
      } catch (e) {
        this.$set(this.form.coachRegionPairs[index], 'regionOptions', [])
      }
    },
    addCoachRegionPair() {
      this.form.coachRegionPairs.push({ coachId: '', regionId: '', regionOptions: [] })
    },
    removeCoachRegionPair(index) {
      this.form.coachRegionPairs.splice(index, 1)
    },
    async editTimeSlot(row) {
      this.isEdit = true;
      this.visible = true;
      // 预填已选车辆/教练/区域的可选项
      await this.handleVehicleChange(row.vehicleId)
      await this.handleCoachChange(row.coachId)
      this.form = {
        id: row.timeSlotId || row.id || '',
        coachId: row.coachId || '',
        vehicleId: row.vehicleId || '',
        startDateTime: row.startDateTime || '',
        endDateTime: row.endDateTime || '',
        notes: row.notes || '',
        price: row.price || '',
        regionId: row.regionId || '',
      };
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    async deleteCoach(row) {
      try {
        const res = await axios.delete(`/api/time-slots/${row.timeSlotId}`);
        if (res.data && res.data.code && res.data.code !== 200) {
          this.$message.error(res.data.message || '删除失败');
        } else {
          this.$message.success('删除成功');
          this.fetchCoaches();
        }
      } catch (e) {
        this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : '删除失败');
      }
    },
    async handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        const params = {
          id: this.form.id,
          coachId: this.form.coachId,
          vehicleId: this.form.vehicleId,
          startDateTime: this.form.startDateTime,
          endDateTime: this.form.endDateTime,
          notes: this.form.notes,
          price: this.form.price,
          regionId: this.form.regionId,
        };
        try {
          let nowId = '';
          if (this.isEdit && this.form.id) {
            const res = await axios.put(`/api/time-slots/${this.form.id}`, params);
            if (res.data && res.data.code && res.data.code !== 200) {
              this.$message.error(res.data.message || '编辑失败');
              return;
            }
            nowId = res.data.id;
          } else {
            // 新增：为每组教练/区域创建一条排班
            const base = {
              vehicleId: this.form.vehicleId,
              startDateTime: this.form.startDateTime,
              endDateTime: this.form.endDateTime,
              notes: this.form.notes,
              price: this.form.price,
            }
            // 过滤掉未选择完整的 pair
            const validPairs = (this.form.coachRegionPairs || []).filter(p => p.coachId && p.regionId)
            if (validPairs.length === 0) {
              this.$message.error('请至少添加一组完整的教练与区域')
              return
            }
            for (const p of validPairs) {
              const payload = { ...base, coachId: p.coachId, regionId: p.regionId }
              const res = await axios.post('/api/time-slots', payload)
              if (res.data && res.data.code && res.data.code !== 200) {
                this.$message.error(res.data.message || '新增失败')
                return
              }
              nowId = res.data.id || 'ok'
            }
          }
          if (nowId) {
            this.$message.success(`${this.isEdit ? '编辑' : '新增'}时间段成功`);
          } else {
            this.$message.error(`${this.isEdit ? '编辑' : '新增'}时间段失败`);
          }
          this.visible = false;
          this.isEdit = false;
          this.page = 1;
          this.fetchCoaches();
        } catch (e) {
          this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : `${this.isEdit ? '编辑' : '新增'}时间段失败`);
        }
      });
    },
    async fetchCoaches() {
      try {
        const res = await axios.get('/api/time-slots/search/details/paged', {
          params: {
            page: this.page,
            size: this.size,
            coachName: this.searchForm.coachName,
            vehicleType: this.searchForm.vehicleType,
            startDateTime: this.searchForm.startDateTime,
            endDateTime: this.searchForm.endDateTime
          }
        });
        this.coaches = res.data.content || [];
        this.total = res.data.totalElements || 0;
      } catch (e) {
        this.$message.error('获取教练列表失败');
      }
    },
    handlePageChange(val) {
      this.page = val;
      this.fetchCoaches();
    },
    handleSearch() {
      this.page = 1;
      this.fetchCoaches();
    },
    handleReset() {
      this.searchForm = {
        coachName: '',
        vehicleType: '',
        startDateTime: '',
        endDateTime: ''
      };
      this.page = 1;
      this.fetchCoaches();
    },
    async loadVehicleOptions() {
      try {
        const res = await axios.get('/api/vehicles', { params: { page: 1, size: 1000 } });
        this.vehicleOptions = res.data || [];
      } catch (e) {
        this.vehicleOptions = [];
      }
    },
    viewAppointments(row) {
      this.$router.push({
        path: '/order',
        query: { timeSlotId: row.timeSlotId }
      });
    }
  },
  mounted() {
    this.loadVehicleOptions();
    this.fetchCoaches();
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 24px 18px 0 18px;
  background: #f6f8fa;
  min-height: 100%;
}

.card-top {
  margin-bottom: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.card-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-table {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.el-table {
  font-size: 15px;
  border-radius: 6px;
  overflow: hidden;
}

.table-pagination {
  margin-top: 18px;
  text-align: right;
}


.close-icon {
  position: absolute;
  top: 2px;
  right: 2px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  z-index: 2;
  padding: 2px;
  transition: background 0.2s;
}

.close-icon:hover {
  background: rgba(255, 0, 0, 0.7);
}



.dialog-footer {
  text-align: right;
}

.pair-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.pair-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.pair-select {
  flex: 1;
  min-width: 220px;
}
.pair-form-item {
  margin-bottom: 0;
}

/* 使校验错误信息占据正常文档流，避免被内容遮挡 */
.pair-form-item ::v-deep .el-form-item__error {
  position: static;
  margin-top: 4px;
  line-height: 1.2;
}

/* 防止标签文本覆盖内容，拉开表单项间距 */
.el-form-item {
  align-items: flex-start;
}
.pair-hint {
  color: #909399;
  font-size: 12px;
  margin-top: 4px;
}
</style>